import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export const NewThreadForm = ({ kind, onCreated, prefix }) => {
  const { user } = useAuth();
  const [f, setF] = useState({ name: user.full_name || "", email: user.email || "", subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const { data } = await api.post("/support/threads", { kind, ...f }); toast.success(kind === "TICKET" ? `Talebiniz iletildi (${data.ticket_no})` : "Mesajınız iletildi"); onCreated(data); }
    catch (x) { toast.error(formatApiError(x.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="space-y-2.5 p-3" data-testid={`${prefix}-form`}>
      <div className="grid grid-cols-2 gap-2">
        <div><Label className="text-xs">Adınız *</Label><Input data-testid={`${prefix}-name`} required minLength={2} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></div>
        <div><Label className="text-xs">E-posta *</Label><Input data-testid={`${prefix}-email`} type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} /></div>
      </div>
      {kind === "TICKET" && <div><Label className="text-xs">Konu *</Label><Input data-testid={`${prefix}-subject`} required minLength={2} value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} /></div>}
      <div><Label className="text-xs">Mesaj *</Label><Textarea data-testid={`${prefix}-message`} required rows={kind === "TICKET" ? 4 : 3} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} /></div>
      <Button data-testid={`${prefix}-submit`} type="submit" disabled={busy} className="w-full bg-emerald-600 hover:bg-emerald-700">{kind === "TICKET" ? "Talebi gönder" : "Sohbeti başlat"}</Button>
    </form>
  );
};
